import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Output,
    ViewChild,
    ViewEncapsulation,
    EventEmitter,
} from '@angular/core';

@Component({
    selector: 'fi-chat-conversation-search',
    template: `
        @if (!isSearchShown) {
          <div class="conversation-search-placeholder-container" (click)="toggleSearchStatus()">
            <mat-icon class="fi-chat-conversation-search-icon fas fa-search"></mat-icon>
            <span class="conversation-search-placeholder">{{ 'chat.find_conversation' | fiAppText }}</span>
          </div>
        }
        @if (isSearchShown) {
          <div class="conversation-search-input-container">
            <mat-form-field appearance="outline" class="mat-form-field-no-border-outline conversation-search-input">
              <input
                matInput
                #searchInput
                autocomplete="off"
                [(ngModel)]="searchValue"
                (ngModelChange)="applySearch()"
                />
                <mat-icon
                  matSuffix
                  class="fi-chat-conversation-search-reset-icon fas fa-times"
                  (click)="resetSearchValue()"
                ></mat-icon>
              </mat-form-field>
            </div>
          }
        `,
    styleUrls: ['./fi-chat-conversation-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-chat-conversation-search' },
    standalone: false,
})
export class FiChatConversationSearchComponent {
    @ViewChild('searchInput') searchInput: ElementRef;
    @Output() search = new EventEmitter<string>();
    isSearchShown = false;
    searchValue = '';

    toggleSearchStatus() {
        this.isSearchShown = !this.isSearchShown;
        this.focusInput();
    }

    private focusInput() {
        if (this.isSearchShown) {
            setTimeout(() => {
                if (this.searchInput) {
                    this.searchInput.nativeElement.focus();
                }
            });
        }
    }

    applySearch() {
        this.search.emit(this.searchValue.trim());
    }

    resetSearchValue() {
        this.toggleSearchStatus();
        this.searchValue = '';
        this.applySearch();
    }
}
